import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Paragraph.scss';

const Paragraph = (props) => {
  const {
    dark,
    primary,
    secondary,
    tertiary,
    children,
    style,
    blogClassIE,
    bold,
    className,
  } = props;

  const classes = {
    paragraph: true,
    dark,
    primary,
    secondary,
    tertiary,
    blogClassIE,
    bold,
  };

  return (
    <p style={style} className={classNames(classes, className)}>
      { children }
    </p>
  );
};

Paragraph.defaultProps = {
  dark: false,
  primary: false,
  secondary: false,
  bold: false,
  tertiary: false,
  children: null,
  style: {},
  blogClassIE: null,
  className: '',
};

Paragraph.propTypes = {

  style: PropTypes.shape({}),

  /** Theme primary */
  dark: PropTypes.bool,
  bold: PropTypes.bool,

  /** Style primary */
  primary: PropTypes.bool,

  /** Style secondary */
  secondary: PropTypes.bool,

  /** Style tertiary */
  tertiary: PropTypes.bool,
  children: PropTypes.node,

  blogClassIE: PropTypes.string,

  className: PropTypes.string,
};

export default Paragraph;
